





import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class CharacterCounter extends Vue {
  @Prop() text: string;
  @Prop() maxLength: number;
  @Prop() suffix: string;

  get visible(): boolean {
    return !!this.text && !!this.maxLength;
  }

  get warning(): boolean {
    return this.visible && this.text.length > this.maxLength;
  }

  get counterText(): string {
    return this.visible ? `${this.text.length} / ${this.maxLength} ${this.suffix || ''}` : `0 / 0`;
  }
}
